import { createAction, createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: true,
  technicalQBData: [],
  questionDetails: {},
  ediQuestionData: {},
  skillList: [],
  expertiseList: [],
  rephraseData: {
    actualText: '',
    suggestions: []
  },
  importQuestionLoader: false,
  message: '',
  errors: '',
  toastSeverity: ''
};

export const technicalQuestionBankSlice = createSlice({
  name: 'technicalQuestionBank',
  initialState,
  reducers: {
    setTechnicalQBLoader: (state, action) => {
      state.isLoading = action.payload;
    },
    setTechnicalQBData: (state, action) => {
      state.technicalQBData = action.payload;
    },
    setQuestionDetailsTQB: (state, action) => {
      state.questionDetails = action.payload;
    },
    setEditQuestionDataTQB: (state, action) => {
      state.ediQuestionData = action.payload;
    },
    setSkillListTQB: (state, action) => {
      state.skillList = action.payload;
    },
    setExpertiseListTQB: (state, action) => {
      state.expertiseList = action.payload;
    },
    setRephraseDataTQB: (state, action) => {
      state.rephraseData = action.payload;
    },
    setImportQuestionLoader: (state, action) => {
      state.importQuestionLoader = action.payload;
    },
    setTQBSuccessMessage: (state, action) => {
      state.message = action.payload;
      state.errors = '';
      state.toastSeverity = 'success';
    },
    setTQBErrorMessage: (state, action) => {
      state.errors = action.payload;
      state.message = '';
      state.toastSeverity = 'error';
    },
    setTQBToast: (state, action) => {
      state.message = action.payload?.message ?? '';
      state.errors = action.payload?.errors ?? '';
      state.toastSeverity = action.payload?.severity ?? '';
    },
    resetTQBMessage: (state) => {
      state.message = '';
      state.errors = '';
      state.toastSeverity = '';
    }
  }
});

export const getTechnicalQBAction = createAction('GET_TECHNICAL_QUESTION_BANK');
export const getQuestionDetailsForPreviewTQBAction = createAction('GET_TECHNICAL_QUESTION_BANK_PREVIEW');
export const getEditQuestionDataTQBAction = createAction('GET_EDIT_QUESTION_DATA_TQB');
export const getRephraseSuggestionsTQBAction = createAction('GET_REPHRASE_SUGGESTIONS');
export const saveQuestionTQBAction = createAction('SAVE_QUESTION_TQB');
export const saveQuestionsFromExcelAction = createAction('SAVE_QUESTIONS_FROM_EXCEL');
export const deleteQuestionTQBAction = createAction('DELETE_QUESTION_TQB');

export const {
  setTechnicalQBLoader,
  setTechnicalQBData,
  setQuestionDetailsTQB,
  setEditQuestionDataTQB,
  setSkillListTQB,
  setExpertiseListTQB,
  setRephraseDataTQB,
  setImportQuestionLoader,
  setTQBSuccessMessage,
  setTQBErrorMessage,
  setTQBToast,
  resetTQBMessage
} = technicalQuestionBankSlice.actions;

export default technicalQuestionBankSlice.reducer;
